import React, { ReactNode, useEffect } from "react";
import { Provider } from "react-redux";
import usermgtStore, { UsermgtContext } from "./usermgtStore";
import {
    getClearanceLevelsFromServer,
    getClearanceLevelsFromServerThatUserHasAccess,
    getFilteredClearanceLevelsFromServer,
} from "./msgs/levelCallers";
import { getGlobalStates } from "userful-chronos-app-common-js/dist/globalstates/globalStates";
import { getUserManagementDataFromServer, getUsernameIdsFromServer } from "./msgs/apiCallers";
interface IProps {
    appID?: string;
    children: ReactNode;
}

function UsermgtProvider(props: IProps) {
    // fetching clearance level data after evvery 5 seconds
    useEffect(() => {
        if (getGlobalStates().keycloak) {
            getClearanceLevelsFromServer(getGlobalStates().keycloak.token);
            getClearanceLevelsFromServerThatUserHasAccess(getGlobalStates().keycloak.token);
            getFilteredClearanceLevelsFromServer(getGlobalStates().keycloak.token);
        }

        //TODO: it is not longer necessary to fetch this data every 5es. Once tested, we can remove this commented out section

        // const allLevels = setInterval(() =>
        //     getGlobalStates().keycloak && getClearanceLevelsFromServer(getGlobalStates().keycloak.token), 5000);
        // const levelsThatUserHasAccess = setInterval(() =>
        //     getGlobalStates().keycloak && getClearanceLevelsFromServerThatUserHasAccess(getGlobalStates().keycloak.token), 5000);
        // const filteredLevels = setInterval(() =>
        //     getGlobalStates().keycloak && getFilteredClearanceLevelsFromServer(getGlobalStates().keycloak.token), 5000);

        // return () => {
        //     clearInterval(allLevels);
        //     clearInterval(levelsThatUserHasAccess);
        //     clearInterval(filteredLevels);
        // }
    }, []);

    useEffect(() => {
        if (getGlobalStates().userPermission.isAdminUser) getUsernameIdsFromServer(getGlobalStates().keycloak?.token);
    }, []);

    return (
        <Provider store={usermgtStore} context={UsermgtContext}>
            {props.children}
        </Provider>
    );
}

export default UsermgtProvider;
